export class TypedValues {
    [key: string]: Array<string>;
}

export interface TypedValue {
    type: string;
    value: string;
}

export const typedValueComparator: (tv1: TypedValue, tv2: TypedValue) => boolean = (
    tv1: TypedValue,
    tv2: TypedValue
) => {
    return tv1.type === tv2.type && tv1.value === tv2.value;
};
